// extracted by css-extract-rspack-plugin
export default {"defaultLink":"SignIn_defaultLink__GDjDO","centeredLink":"SignIn_centeredLink__H34-x"};